import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ee938d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "status" }
const _hoisted_3 = { class: "buttons" }
const _hoisted_4 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_5 = ["href", "data-dp-tooltip"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "visibility", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["data-dp-tooltip"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "edit", -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseDeleteButton = _resolveComponent("BaseDeleteButton")!

  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", _hoisted_1, _toDisplayString(_ctx.contentBlock.title), 1),
    _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.contentBlock.status.description), 1),
    _createElementVNode("td", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.previewPath)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _ctx.previewPath,
              target: "_blank",
              class: "btn btn-icon btn-primary ms-2",
              "data-dp-tooltip": _ctx.$t('preview')
            }, _hoisted_7, 8, _hoisted_5))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update', _ctx.contentBlock))),
          class: "btn btn-icon btn-primary ms-2",
          "data-dp-tooltip": _ctx.$t('edit')
        }, _hoisted_10, 8, _hoisted_8),
        _createVNode(_component_BaseDeleteButton, {
          deleteData: () => _ctx.$emit('delete', _ctx.contentBlock),
          itemKey: _ctx.contentBlock.id,
          pageUI: _ctx.pageUI,
          class: "ms-2"
        }, null, 8, ["deleteData", "itemKey", "pageUI"])
      ])
    ])
  ]))
}